import DropdownRegionItem from "gatsby-theme-dettol/src/components/DropdownRegion/DropdownRegionItem/DropdownRegionItem"

import "./DropdownRegionItemOverride.scss"

export default DropdownRegionItem